import { AnalysisFileType } from "../../../types/analysisFileTypes";
import GenericAnalysisFilesPage from "./GenericAnalysisFilesPage";


export default function DirectPayoutAnalysisFilesPage() {
    return <GenericAnalysisFilesPage
        fileType={AnalysisFileType.DirectPayoutAnalysisFile}
        title={"analysisPage.directPayout.title"}
    />
}